import { render, staticRenderFns } from "./ConsultaCA.vue?vue&type=template&id=4fcf9867&scoped=true"
import script from "./ConsultaCA.vue?vue&type=script&lang=js"
export * from "./ConsultaCA.vue?vue&type=script&lang=js"
import style0 from "./ConsultaCA.vue?vue&type=style&index=0&id=4fcf9867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcf9867",
  null
  
)

export default component.exports